export default __webpack_public_path__ + "static/media/subtract_icon.7e4e7596.svg";